import { render } from "./adminsettings-sidebar.vue?vue&type=template&id=01e394da"
import script from "./adminsettings-sidebar.vue?vue&type=script&lang=js"
export * from "./adminsettings-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__